import { useEffect, useState } from 'react';

export const useDeferUntilIdle = ({ timeout = 3000 } = {}) => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const run = () => {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(() => setReady(true), { timeout });
      } else {
        // fallback for Safari/older browsers
        setTimeout(() => setReady(true), 0);
      }
    };

    if (document.readyState === 'complete') {
      run();
    } else {
      window.addEventListener('load', run, { once: true });
    }
  }, [timeout]);

  return ready;
};